import React from "react";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useAppState } from "../../../../context/StateContext";
import deleteAllTokens from "../../../../util/deleteAllTokens";
import {
  LogoImage,
  UpdatedContainer,
  UpdatedPasswordInfo,
  UpdatedPasswordTitle,
  UpdatedPasswordSubtitle,
  TextLink,
} from "./styles";

const UpdatedScreen = () => {
  const { subDomainInfo } = useAppState();

  const { currentUser, setCurrentCustomerUser } = useAppState();

  const { t: translate } = useTranslation();

  const history = useHistory();

  const redirectToLogin = () => {
    if (currentUser) {
      deleteAllTokens();
      setCurrentCustomerUser(undefined);
    }

    history.replace("/");
  };

  return (
    <UpdatedContainer>
      <LogoImage src={subDomainInfo?.logo} />

      <UpdatedPasswordInfo>
        <UpdatedPasswordTitle>{translate("yourPasswordHasBeenUpdated")}</UpdatedPasswordTitle>
        <UpdatedPasswordSubtitle>
          {translate("youWillBeRedirectedToTheSignInPageIfYouAreNotRedirectedAutomatically")}
          <TextLink onClick={() => redirectToLogin()}>{translate("clickHere")}</TextLink>
        </UpdatedPasswordSubtitle>
      </UpdatedPasswordInfo>
    </UpdatedContainer>
  );
};

export default UpdatedScreen;
